<template>
  <a :href="ConfigShopURL" target="_blank" class="shop-banner">
    <div class="shop-banner__glow"></div>
    <div class="shop-banner__inner">
      <div class="shop-banner__badge">
        <img class="flag-icon" src="https://flagcdn.com/us.svg" width="16" height="11" alt="USA Flag" />
        <span>USA Direct</span>
      </div>

      <div class="shop-banner__content">
        <span class="shop-banner__main">
          <strong>100% Certified OEM Supplies</strong> — Genuine ink, toner &amp; paper shipped nationwide
        </span>
      </div>

      <div class="shop-banner__action">
        <span>Shop Supplies</span>
        <svg class="action-arrow" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"></path>
          <path d="M12 5l7 7-7 7"></path>
        </svg>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { ConfigShopURL } = storeToRefs(store)
</script>

<style scoped>
.shop-banner {
  position: relative;
  display: block;
  text-decoration: none;
  background: linear-gradient(90deg, #091b36 0%, #0f356d 40%, #1e4ea8 70%, #173d80 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  z-index: 100;
}

.shop-banner__glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
  transform: skewX(-25deg);
  animation: bannerShimmer 7s infinite ease-in-out;
  pointer-events: none;
}

@keyframes bannerShimmer {
  0% { left: -100%; }
  25% { left: 200%; }
  100% { left: 200%; }
}

.shop-banner__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 7px 16px;
  max-width: 1440px;
  margin: 0 auto;
  min-height: 36px;
}

.shop-banner__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 9999px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  flex-shrink: 0;
}

.flag-icon {
  border-radius: 2px;
  object-fit: cover;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.shop-banner__content {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.92);
  letter-spacing: 0.01em;
  text-align: center;
}

.shop-banner__main strong {
  color: #ffffff;
  font-weight: 700;
}

.shop-banner__action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  color: #0f356d;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 2.5px 10px;
  border-radius: 9999px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.action-arrow {
  transition: transform 0.2s ease;
}

.shop-banner:hover {
  background: linear-gradient(90deg, #0b2244 0%, #123d7d 40%, #255ebc 70%, #1c4996 100%);
}

.shop-banner:hover .shop-banner__action {
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  transform: scale(1.03);
}

.shop-banner:hover .action-arrow {
  transform: translateX(3px);
}

@media (max-width: 768px) {
  .shop-banner__inner {
    padding: 6px 12px;
    gap: 8px;
  }
  .shop-banner__badge {
    display: none;
  }
  .shop-banner__content {
    font-size: 11.5px;
    line-height: 1.3;
  }
  .shop-banner__action {
    padding: 2px 8px;
    font-size: 11px;
  }
}
</style>
